import localforage from 'localforage';
localforage.config({
    driver: [localforage.INDEXEDDB,
        localforage.LOCALSTORAGE
    ],
    name: 'db-root'
});


export const storage = {
    set(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        return JSON.parse(window.localStorage.getItem(key));
    },
    remove(key) {
        window.localStorage.removeItem(key);
    },
    setItem(key, value) {
        if (!key) return;
        try {
            return localforage.setItem(key, value)
        } catch (error) {
            return Promise.reject(error);
        }
    },
    getItem(key) {
        if (!key) return;
        try {
            return localforage.getItem(key)
        } catch (error) {
            return Promise.reject(error);
        }
    },
    removeItem(key) {
        if (!key) return;
        try {
            return localforage.removeItem(key)
        } catch (error) {
            return Promise.reject(error);
        }
    }
};

// 深拷贝数组
export const deepClone = (obj) => {
    let result = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object') {
                result[key] = deepClone(obj[key]);
            } else {
                result[key] = obj[key];
            }
        }
    }
    return result;
};
